import React from 'react'
import { Link } from 'react-router-dom'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../ui/SafeIcon'

const { FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiYoutube } = FiIcons

function Footer() {
  const footerLinks = {
    'Get Support': [
      { name: 'Help Center', path: '/help' },
      { name: 'Live Chat', path: '/help' },
      { name: 'Check Order Status', path: '/orders' },
      { name: 'Refunds', path: '/help' },
      { name: 'Report Abuse', path: '/help' }
    ],
    'Payments and Protections': [
      { name: 'Safe Payments', path: '/help' },
      { name: 'Trade Assurance', path: '/buyer-central' },
      { name: 'Buyer Protection', path: '/buyer-central' }
    ],
    'Source on 1688Euro': [
      { name: 'Request for Quotation', path: '/search' },
      { name: 'Membership Program', path: '/seller' },
      { name: 'Logistics Services', path: '/buyer-central' },
      { name: 'Sales Tax FAQ', path: '/help' }
    ],
    'Sell on 1688Euro': [
      { name: 'Start Selling', path: '/seller' },
      { name: 'Seller Central', path: '/seller' },
      { name: 'Become a Verified Supplier', path: '/seller' },
      { name: 'Partnerships', path: '/seller' }
    ],
    'About Us': [
      { name: 'About 1688Euro', path: '/help' },
      { name: 'Corporate Responsibility', path: '/help' },
      { name: 'News & Media', path: '/help' },
      { name: 'Careers', path: '/help' }
    ]
  }

  return (
    <footer className="bg-white border-t border-gray-200 pt-12 pb-8 text-sm">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Newsletter & Socials */}
        <div className="flex flex-col md:flex-row justify-between items-center border-b border-gray-200 pb-8 mb-8">
          <div className="mb-6 md:mb-0 text-center md:text-left">
            <h3 className="font-bold text-gray-900 text-lg mb-1">
              Trade Alert - Delivering the latest product trends and industry news straight to your inbox.
            </h3>
            <div className="flex max-w-md mt-4">
              <input
                type="email"
                placeholder="Your email"
                aria-label="Newsletter E-Mail-Adresse"
                className="flex-1 border border-gray-300 px-4 py-2 rounded-l-md focus:outline-none focus:border-[#FF6600]"
              />
              <button
                className="bg-[#FF6600] text-white px-6 py-2 rounded-r-md font-bold hover:bg-[#e55c00]"
                aria-label="Newsletter abonnieren"
              >
                Subscribe
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              We'll never share your email address with a third-party.
            </p>
          </div>
          <div className="flex space-x-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <SafeIcon icon={FiFacebook} className="w-6 h-6 text-gray-400 hover:text-[#FF6600] cursor-pointer" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <SafeIcon icon={FiTwitter} className="w-6 h-6 text-gray-400 hover:text-[#FF6600] cursor-pointer" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <SafeIcon icon={FiInstagram} className="w-6 h-6 text-gray-400 hover:text-[#FF6600] cursor-pointer" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <SafeIcon icon={FiLinkedin} className="w-6 h-6 text-gray-400 hover:text-[#FF6600] cursor-pointer" />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <SafeIcon icon={FiYoutube} className="w-6 h-6 text-gray-400 hover:text-[#FF6600] cursor-pointer" />
            </a>
          </div>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-bold text-gray-900 mb-4">{title}</h4>
              <ul className="space-y-2">
                {links.map(link => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-gray-600 hover:text-[#FF6600] hover:underline">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar - CRITICAL: Legal Links müssen direkt erreichbar sein! */}
        <div className="bg-gray-50 rounded-lg p-4 text-center text-xs text-gray-500">
          <div className="mb-2 flex flex-wrap justify-center gap-x-3 gap-y-1">
            <Link to="/impressum" className="hover:underline font-medium">Impressum</Link>
            <span className="text-gray-300">•</span>
            <Link to="/datenschutz" className="hover:underline font-medium">Datenschutzerklärung</Link>
            <span className="text-gray-300">•</span>
            <Link to="/agb" className="hover:underline font-medium">AGB</Link>
            <span className="text-gray-300">•</span>
            <Link to="/widerruf" className="hover:underline font-medium">Widerruf</Link>
            <span className="text-gray-300">•</span>
            <Link to="/barrierefreiheit" className="hover:underline font-medium">Barrierefreiheit</Link>
            <span className="text-gray-300">•</span>
            <a 
              href="https://ec.europa.eu/consumers/odr" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:underline font-medium"
            >
              EU-Streitschlichtung
            </a>
          </div>
          <p className="mt-2">© 2024 AIQCON GmbH. All rights reserved. | 1688Euro.com</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer